export const LEAD_STREAM_VALUES = [
  'Grade 10',
  'Grade 11',
  'Grade 12',
  'Diploma',
  'College',
  'Graduate',
  'Post Graduate',
] as const;

export type LeadStream = (typeof LEAD_STREAM_VALUES)[number];

export const LEAD_STREAM_OPTIONS: readonly LeadStream[] = LEAD_STREAM_VALUES;

export function resolveLeadStreamValue(value?: string | null): LeadStream | undefined {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  if ((LEAD_STREAM_VALUES as readonly string[]).includes(trimmed)) {
    return trimmed as LeadStream;
  }
  return undefined;
}
